import { zh } from '../i18n';
import { useStreamState } from '../stream/StreamProvider';

/**
 * The one-line truth about the socket (SPEC §10). It renders nothing while the
 * stream is healthy — a permanent "connected" chip would train people to ignore
 * the strip exactly when it starts mattering.
 */
export function ConnectionStrip(): JSX.Element | null {
  const { connection } = useStreamState();

  if (connection === 'open' || connection === 'idle') return null;

  if (connection === 'offline') {
    return (
      <div className="strip strip--error" role="status">
        {zh.connection.offline}
      </div>
    );
  }

  return (
    <div className="strip strip--warn" role="status">
      <span className="spinner" aria-hidden="true" />
      {zh.connection.reconnecting}
    </div>
  );
}
